import Label from 'components/Label';


const FutureSideText = ({ title, desc, tag }) => {
    return (
        <div className='features-sidetext'>
            <Label text={tag} />
            <h2>{title}</h2>
            <p className="body1">{desc}</p>
        </div>
    );
}

export default FutureSideText;